import { arrayOf, bool, shape, string } from 'prop-types'

export const shopLanguagesType = shape({
  title: string,
  languages: arrayOf(
    shape({
      text: string,
      href: string,
      code: string,
      selected: bool,
    })
  ),
})
